import { createAction } from '@'
import { $formValues } from '../stores'

export default createAction('UpdateFormValues', (name, values) => {
    $formValues.subStore(name).setState(() => values)
})
